@let prod = product();
@let dp = distinctProduct();
@let fp = forcePrice();
@if (! fp) {
  @if (prod) {
    @if (prod.priceFrom === 0 && ! distinctProduct() && (! productPrice() || (! productPrice()?.normal && ! productPrice()?.normalFrom && ! productPrice()?.special && ! productPrice()?.specialFrom))) {
      <span >
        Preis von Konfiguration abhängig
      </span>
    } @else {
      @let pp = productPrice();
      @if (pp) {
        @if (pp.special) {
          <span>
            @if (pp.normal && pp.normal > 0 && pp.normal > pp.special) {
              <span class="discount-old">statt {{ pp.normal | price }}</span>
            }
            <gea-svg-event-stars [size]="32"></gea-svg-event-stars>
            <span class="discount-new">{{ pp.normalFrom ? 'ab ' : ''}}{{ pp.special | price }}</span>
          </span>
        }
        @else if (pp.specialFrom) {
          <span>
            @if (pp.normal && pp.normal > 0 && pp.normal > pp.specialFrom) {
              <span class="discount-old">statt {{ pp.normal | price }}</span>
            }
            <gea-svg-event-stars [size]="32"></gea-svg-event-stars>
            <span class="discount-new">{{ (pp.specialFrom || pp.normalFrom) ? 'ab ' : ''}}{{ pp.specialFrom | price }}</span>
          </span>
        }
        @else {
          @if (dp) {
            <span>
              {{ dp.price | price }}
            </span>
          } @else {
            <span>
              @if ((pp.normalFrom) || (prod.typeId == 2)) {
                <span> ab </span>
              }
              {{ pp.normalFrom ?? pp.normal | price }}
            </span>
          }
        }
      }
    }
  }
} @else {

  <!-- force price set -->
  @if (typeof fp === 'number') {
    <span>
      @if (discount) {
        <span>
          <small class="discount-old">{{ fp | price }}</small>
          <span class="discount-new">{{ (fp - fp * (discount / 100)) | price }}</span>
        </span>
      } @else {
        {{ fp | price }}
      }

    </span>
  } @else {
    <span>
      @if (fp.special && fp.normal) {
        @if (fp.normal > 0 && fp.special < fp.normal) {
          <span class="discount-old">statt {{ fp.normal | price }}</span>
        }
        <gea-svg-event-stars [size]="32"></gea-svg-event-stars>
        <span class="discount-new">{{ (fp.specialFrom || fp.normalFrom) ? 'ab ' : ''}}{{ fp.specialFrom ?? fp.special | price }}</span>
      } @else if (fp.normal) {
        {{ fp.normal | price }}
      } @else if (fp.normalFrom) {
        ab {{ fp.normalFrom | price }}
      }
    </span>
  }
}